import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestGrid from "@/pages/home/components/LatestGrid";
import FeaturedCollections from "@/pages/home/components/FeaturedCollections";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <div className="w-full">
      <h1 className="sr-only">邻居的妻子影视大全 - 剧情介绍与最新剧集观看</h1>
      <HeroCarousel />
      <CategoryEntries />
      <LatestGrid />
      <FeaturedCollections />
      <SiteIntro />
    </div>
  );
}